import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { StyledTableCell } from "../../../components/filesListTable/styles";
import ConciseTable from "../../../components/filesListTable/conciseTable";
import { ThreeDotsPopupMenu } from "../../../components/threeDotsPopupMenu";
import { useHistory } from "react-router-dom";
import Spinner from "../../../components/spinner";

import {
  StyledProjectSelectionContainer,
  MobileColumnContent,
  MobileColumnText,
  StyledDownloadedContainer,
  StyledReviewedContainer,
  StyledDraftContainer,
} from "./styles";

import { truncateString } from "../../../common/truncateString";
import { ESUBData } from "pages/newPreQualify/components/bondDetails/types";

type ESUBListProps = {
  filteredData: ESUBData[];
  editFunc: (id: string) => void;
  deleteFunc: (id: string) => void;
  isMobile: boolean;
  isContractorView: boolean;
  isLoading?: boolean;
}

export const ESUBList = ({ 
  filteredData, 
  editFunc, 
  deleteFunc, 
  isMobile,
  isContractorView,
  isLoading = false
}: ESUBListProps) => {
  const headers = isContractorView ? [
    { title: "Project Title", width: "60%" },
    { title: "Status", align: "center", width: "15%" },
    { title: "Prepared/Submitted", width: "15%" },
    { title: "Actions", width: "10%" },
  ] : [
    { title: "Contractor Name", width: "30%" },
    { title: "Project Title", width: "30%" },
    { title: "Status", align: "center", width: "15%" },
    { title: "Prepared/Submitted", width: "15%" },
    { title: "Actions", width: "10%" },
  ];


  let history = useHistory();

  const handleOnboarding = () => {
    history.push("/contractor-dashboard");
  };

  const handleReviewEsub = (id: string) => {
    history.push("/prequalify/preview/", {
      action: "edit-esub",
      section: "esub",
      esubId: id,
    });
  };

  const body = (bodyData: ESUBData) => {
    return (
      <>
        {isMobile && (
          <StyledTableCell width="90%">
            <MobileColumnContent>
              <MobileColumnText>
                {truncateString(bodyData.project_title, 28)}
              </MobileColumnText>
              <MobileColumnText style={{ fontSize: "12px", fontWeight: 400 }}>
                {truncateString(bodyData.owner_city, 30)}
              </MobileColumnText>
            </MobileColumnContent>
          </StyledTableCell>
        )}
        {!isMobile && (
          <>
            {!isContractorView && (
              <StyledTableCell width="30%">
                {bodyData.contractor_name || "-"}
              </StyledTableCell>
            )}
            <StyledTableCell width="30%">
              {bodyData.project_title || "-"}
            </StyledTableCell>
            <StyledTableCell width="15%">
              {bodyData.status === null ? (
                <StyledDraftContainer>Draft</StyledDraftContainer>
              ) : bodyData.status === "Reviewed" ? (
                <StyledReviewedContainer>Reviewed</StyledReviewedContainer>
              ) : bodyData.status === "Submitted" ? (
                <StyledDownloadedContainer>Submitted</StyledDownloadedContainer>
              ) : bodyData.status === "Downloaded" ? (
                <StyledDownloadedContainer>
                  Downloaded
                </StyledDownloadedContainer>
              ) : (
                ""
              )}
            </StyledTableCell>
            <StyledTableCell width="15%">
              {new Date(bodyData.updated_at).toLocaleDateString() || "-"}
            </StyledTableCell>
          </>
        )}
        <StyledTableCell align="right">
          <ThreeDotsPopupMenu
            item={{ ...bodyData, id: bodyData.esubId }}
            removeEdit={"cloneCcdc"}
            data={filteredData}
            handleSeeAll={handleOnboarding}
            handleModify={editFunc}
            handleDelete={deleteFunc}
            handleReviewEcqs={handleReviewEsub}
            projects={[]}
            setProjects={() => {}}
            icon={null}
            addProjectRemark={() => {}}
            noEditButton={false}
            deleteText=""
            handleDisable={() => {}}
            handleActiveIdpEsub={() => {}}
            handleDeActiveIdpEsub={() => {}}
            handleEnable={() => {}}
            handleShowUserList={() => {}}
            handleAddNewUser={() => {}}
            goToProjectWipPage={() => {}}
          />
        </StyledTableCell>
      </>
    );
  };

  if (isLoading) {
    console.log('ESUBList - Showing loading spinner');
    return (
      <StyledProjectSelectionContainer>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px',
          width: '100%'
        }}>
          <Spinner size={40} color={undefined} />
        </div>
      </StyledProjectSelectionContainer>
    );
  }

  return (
    <StyledProjectSelectionContainer>
      <ConciseTable
        headers={isMobile ? "" : headers}
        body={body}
        data={filteredData}
      />
    </StyledProjectSelectionContainer>
  );
}; 